import React from 'react'
import type { SearchResult, MetaDataHighlight } from '@core/Areas/Search/types'
import {
  isSearchResultAcceptor,
  isSearchResultFobEvent,
  isSearchResultFobProposition,
  isSearchResultRace,
} from '@core/Areas/Search/helpers/typeGuards'
import { AcceptorResult, FobEventResult, FobPropositionResult, RaceResult } from './Components'

export const RacingSearchResult: React.FC<{
  searchResult: SearchResult
  highlights: MetaDataHighlight
}> = ({ searchResult, highlights }) => {
  if (isSearchResultAcceptor(searchResult)) {
    return <AcceptorResult searchResult={searchResult} highlights={highlights} />
  }

  if (isSearchResultRace(searchResult)) {
    return <RaceResult searchResult={searchResult} highlights={highlights} />
  }

  if (isSearchResultFobEvent(searchResult)) {
    return <FobEventResult searchResult={searchResult} highlights={highlights} />
  }

  if (isSearchResultFobProposition(searchResult)) {
    return <FobPropositionResult searchResult={searchResult} highlights={highlights} />
  }

  return null
}
